// extracted by mini-css-extract-plugin
module.exports = {"card-root":"style_card-root__FZeXX"};